import { Button } from '@ps/sports-ui-component-library';
import { Link } from '@ps/web-shared-components';
import type { MeetingId } from '@ps/web-sports-api-types';
import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';
import { ExpandablePanel, RaceStatus } from '@swf/sports/components';
import SportsFormattedTimeZone from '@swf/sports/components/SportsFormattedTimeZone/SportsFormattedTimeZone';
import { getRaceTimeFromRaceId } from '@swf/sports/utils/getRaceTimeFromRaceId';

import { useSportsAnimalRacingMeetingsWidget } from '../../model';
import MeetingTitle from '../MeetingTitle/MeetingTitle';

import styles from './Meeting.scss';

export interface Props {
  id: MeetingId;
  isOpen: boolean;
}

const Meeting: React.FC<Props> = ({ id, isOpen }) => {
  const { widgetSelect } = useSportsAnimalRacingMeetingsWidget();

  const meeting = useSelector((state: RootState) => widgetSelect.meeting(state, id));
  const races = useSelector((state: RootState) => widgetSelect.meetingRaces(state, id));

  const { venueSlug } = meeting;
  const { eventTypeSlug, eventTypeId } = useSelector(select.sports.getUrlParams);

  return (
    <div className={styles.container}>
      <ExpandablePanel
        openInitially={isOpen}
        title={<MeetingTitle meeting={meeting} isOpen={isOpen} />}
      >
        <div className={styles.racesWrapper}>
          <div className={styles.racesGrid}>
            {races.map((race) => {
              const raceTime = getRaceTimeFromRaceId(race.id);

              return (
                <span key={race.id} className={styles.raceButtonWrapper}>
                  <Button
                    as={Link}
                    variant="secondary"
                    size="small"
                    className={styles.raceButton}
                    alias="sportsAnimalRacingRace"
                    values={{
                      eventTypeId,
                      eventTypeSlug,
                      venueSlug,
                      meetingId: meeting.id,
                      raceId: raceTime // TODO: GSFES-649
                    }}
                    fullWidth
                  >
                    {<SportsFormattedTimeZone date={race.startTime} withTime hourCycle="h23" />}
                    {race.status && <RaceStatus status={race.status} iconOnly />}
                  </Button>
                </span>
              );
            })}
          </div>
        </div>
      </ExpandablePanel>
    </div>
  );
};

export default Meeting;
